'use client';

import Button from '../button';
import { CustomArrowsProps } from '../carousel/overlay-carousel/overlay-carousel-component';
import { IconChevronLightLeft, IconChevronLightRight } from '../icon';

// Custom arrows component for image gallery component
export const ImageGalleryArrows = ({ currentPage, totalPages, goToPage }: CustomArrowsProps) => {
	if (totalPages <= 1) return null;

	return (
		<div className="absolute inset-y-0 left-0 right-0 flex items-center justify-between lg:opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
			{/* Previous button - LEFT SIDE*/}
			<div className="relative padding-stack-2xs padding-inline-2xs pointer-events-auto">
				{currentPage > 0 && (
					<Button
						intent="unstyled"
						onClick={() => {
							goToPage(currentPage - 1);
						}}
						className="w-[30px] h-[30px] relative z-99 flex items-center justify-center bg-white hover:bg-button-on-image-primary-hover active:bg-button-primary-pressed rounded-full transition-all duration-300"
						aria-label="Previous image"
					>
						<IconChevronLightLeft width={12} height={12} />
					</Button>
				)}
			</div>

			{/* Next button - RIGHT SIDE*/}
			<div className="relative padding-stack-2xs padding-inline-2xs pointer-events-auto">
				{currentPage < totalPages - 1 && (
					<Button
						intent="unstyled"
						type="button"
						onClick={() => {
							goToPage(currentPage + 1);
						}}
						className="w-[30px] h-[30px] relative z-10 flex items-center justify-center bg-white hover:bg-button-on-image-primary-hover active:bg-button-primary-pressed rounded-full transition-all duration-300"
						aria-label="Next image"
					>
						<IconChevronLightRight width={12} height={12} />
					</Button>
				)}
			</div>
		</div>
	);
};
